export default function isRouteActive(route) {
  return window.location.pathname.includes(route.split('/')[0]);
}
